$(window).on('load', function(){
     
    $('.CustomerReview__DeskSlides').slick({
        lazyLoad: false,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        cssEase: 'linear',
        centerMode: false,
        adaptiveHeight: false,
        
      	responsive: [
           {
              breakpoint: 1250,
              settings: {
                  draggable: true,
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  adaptiveHeight: false
              }
          },
          {
            breakpoint: 1080,
              settings: {
                  draggable: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  adaptiveHeight: true
              }
          },
          {
            breakpoint: 767,
              settings: {
                  draggable: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  adaptiveHeight: true
              }
          },
          {
            breakpoint: 640,
              settings: {
                  centerMode: true,
                  centerPadding:'30px',
                  draggable: true,
                  slidesToShow: 1,
                  adaptiveHeight: true
              }
          }
        ]
      }); 
     $('.CustomerReviewPro__DeskSlides').slick({
        lazyLoad: 'ondemand',
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        cssEase: 'linear',
        centerMode: false,
        adaptiveHeight: false,
      	responsive: [
           {
              breakpoint: 1250,
              settings: {
                  draggable: true,
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  adaptiveHeight: false
              }
          },
          {
            breakpoint: 1080,
              settings: {
                  draggable: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  adaptiveHeight: true
              }
          },
          {
            breakpoint: 767,
              settings: {
                  draggable: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  adaptiveHeight: true
              }
          },
          {
            breakpoint: 640,
              settings: {
                  centerMode: true,
                  centerPadding:'30px',
                  draggable: true,
                  slidesToShow: 1,
                  adaptiveHeight: true
              }
          }
        ]
      }); 
  });
  jQuery(function($){
      // Custom carousel nav
      $('.carousel-prev').click(function(){ 
        $('.CustomerReview__DeskSlides').slick('slickPrev');
      });

      $('.carousel-next').click(function(e){
          e.preventDefault(); 
          $('.CustomerReview__DeskSlides').slick('slickNext');
      });
      $('.carousel-prev-pro').click(function(){ 
          $('.CustomerReviewPro__DeskSlides').slick('slickPrev');
      });

      $('.carousel-next-pro').click(function(e){
          e.preventDefault(); 
          $('.CustomerReviewPro__DeskSlides').slick('slickNext');
      });
  });